import React from 'react';

const UserIcon = ({ width = 20, height = 20, color = '#FFFFFF' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 10C12.7614 10 15 7.76142 15 5C15 2.23858 12.7614 0 10 0C7.23858 0 5 2.23858 5 5C5 7.76142 7.23858 10 10 10Z"
        fill={color}
      />
      <path
        d="M10 12.5C5.58172 12.5 2 14.7386 2 17.5C2 18.8807 5.58172 20 10 20C14.4183 20 18 18.8807 18 17.5C18 14.7386 14.4183 12.5 10 12.5Z"
        fill={color}
      />
    </svg>
  );
};

export default UserIcon;
